import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'

function headersDispositionToFilename (headers: { [x: string]: any; }) {
  const disposition = headers['content-disposition']
  console.log(disposition)
  const matches = /filename=([^;]+)/ig.exec(disposition)
  return ((matches != null ? matches[1] : null) || 'untitled').trim()
}

/**
   * 导出文件自动下载
   * 如果无法取到名字可能是后端问题, 需要在 'Access-Control-Expose-Headers' 内添加 'content-disposition'
   * @param response 响应
   * @param type 导出文件类型, 应用于新建 Blob 的 option.type
   */
export function exportFileDownload (response: { data: BlobPart | null; headers: any }, option?: { type?: string, name?: string}) {
  if (response.data == null) {
    ElMessage.error('下载失败,文件不存在')
    return
  }
  const blob = new Blob([response.data], { type: option?.type ?? 'application/vnd.ms-excel' })
  const fileName = option?.name ? option.name + ' ' + dayjs().format('YYYY-MM-DD') : headersDispositionToFilename(response.headers)
  const objectUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.setAttribute('style', 'display:none')
  a.setAttribute('href', objectUrl)
  a.setAttribute('download', fileName)
  a.click()
  URL.revokeObjectURL(objectUrl)
  ElMessage.success(t('导出成功'))
}
